<template>
  <div>
    <div style="position: absolute; top:0; right: 32px; max-width: 200px" v-if="$store.state.app.organisation"
      class="square-button green admin-btn" @click="exportInventory"
      title="Export the emissions sources, organisation & business units for this inventory period for importing into new dCarbon">
      Export Inventory
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExportInventory',
  methods: {
    exportInventory () {
      const periodId = this.$store.state.app.client?.period?.nodes?.[0]?.id
      if (!periodId) {
        alert('No period loaded. Please load a client first.')
        return
      }
      const url = `${process.env.VUE_APP_APIURL}export-inventory?periodId=${periodId}`
      window.open(url, '_blank')
    }
  }
}
</script>
